import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark-1",
  "use": "icon-checkmark-1-usage",
  "viewBox": "0 0 10.88 8.79",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.88 8.79\" id=\"icon-checkmark-1\"><defs><style>#icon-checkmark-1 .cls-1{fill:none;stroke:#2b0;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><g id=\"icon-checkmark-1_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-checkmark-1_圖層_1-2\" data-name=\"圖層 1\"><polyline class=\"cls-1\" points=\"1 2.88 4 6.88 10 0.88\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol